import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Table, Tag, Typography, notification } from 'antd';
import { useEffect, useState } from 'react';
import apiService from '../../services/api-service';

type WorkItemPageProps = {
  apiUrl?: string;
  title?: string;
};

type WorkItem = {
  id?: number;
  name: string;
  description: string;
  estimateCost: number;
  unitNum: number;
};
const workItemUnitOptions = [
  {
    value: 1,
    label: 'Công lắp',
  },
  {
    value: 2,
    label: 'Công bảo hành',
  },
  {
    value: 3,
    label: 'VNĐ',
  },
];
export default function WorkItemsPage(props: WorkItemPageProps) {
  const apiUrl = '/api/workers/work_items';
  const [data, setData] = useState<WorkItem[]>([]);
  const [currentEditItem, setCurrentEditItem] = useState<WorkItem>();
  const [isCreateNewItem, setIsCreateNewItem] = useState(false);
  const [form] = Form.useForm();

  async function getAllData() {
    try {
      const response = await apiService.get<WorkItem[]>(apiUrl, {
        params: {
          status: [0, 1],
        },
      });
      const sources = response.data;
      if (response.status != 200) {
        throw new Error();
      }
      setData(sources);
    } catch (error: any) {
      notification.error({ message: 'Lỗi tải dữ liệu' });
      console.error(error?.message);
    }
  }
  const onEditItem = (item: WorkItem) => {
    setCurrentEditItem(item);
    form.setFieldsValue(item);
  };
  const onPressCreateNewItem = () => {
    setIsCreateNewItem(true);
  };

  const onCreateNewItem = async () => {
    try {
      const submitData = form.getFieldsValue();
      const response = await apiService.post(apiUrl, submitData);
      if (response.status == 200) {
        notification.success({ message: 'Thêm thành công' });
      }
      form.resetFields();
      setIsCreateNewItem(false);
    } catch (error: any) {
      notification.error({ message: 'Lỗi thêm mới' });
      console.error(error?.message);
    }
  };

  const onUpdateItem = async () => {
    try {
      const submitData: WorkItem = form.getFieldsValue();
      submitData.id = currentEditItem!!.id;
      const response = await apiService.put(`${apiUrl}/${currentEditItem!!.id}`, submitData);
      if (response.status == 200) {
        notification.success({ message: 'Cập nhật thành công' });
      }
      onCloseModal();
      getAllData();
    } catch (error: any) {
      notification.error({ message: 'Lỗi thêm mới' });
      console.error(error?.message);
    }
  };

  const onCloseModal = () => {
    setCurrentEditItem(undefined);
    setIsCreateNewItem(false);
    form.resetFields();
  };
  useEffect(() => {
    getAllData();
  }, []);

  return (
    <div className="p-[24px]">
      <Typography.Title level={4}>{props.title || 'Hạng mục thi công/lắp đặt'}</Typography.Title>
      <div className="mb-[16px]">
        <Button size="large" onClick={onPressCreateNewItem} type="primary">
          Tạo mới
        </Button>
      </div>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Table
            dataSource={data}
            columns={[
              {
                title: '#ID',
                key: 'id',
                dataIndex: 'id',
              },
              {
                title: 'Name',
                key: 'name',
                dataIndex: 'name',
              },
              {
                title: 'Mô tả',
                key: 'description',
                dataIndex: 'description',
              },
              {
                title: 'Hệ số công',
                key: 'estimateCost',
                dataIndex: 'estimateCost',
              },
              {
                title: 'Đơn vị',
                key: 'unitNum',
                dataIndex: 'unitNum',
                render: (unitNum: number) => {
                  let unitText = 'VNĐ';

                  switch (unitNum) {
                    case 1:
                      unitText = 'Công lắp';
                      break;
                    case 2:
                      unitText = 'Công bảo hành';
                      break;
                    default:
                      break;
                  }
                  return <>{unitText}</>;
                },
              },
              {
                title: 'Trạng thái',
                key: 'status',
                dataIndex: 'status',
                render: (status: number) => {
                  let text = <Tag color="red">Không hoạt động</Tag>;
                  switch (status) {
                    case 1:
                      text = <Tag color="green">Hoạt động</Tag>;
                      break;
                  }
                  return text;
                },
              },
              {
                title: '',
                render: record => {
                  return <></>;
                },
              },
            ]}
            onRow={(record, rowIndex) => {
              return {
                onClick: e => onEditItem(record),
              };
            }}
          />
        </Col>
      </Row>
      <Modal
        open={!!currentEditItem || isCreateNewItem}
        destroyOnClose={true}
        cancelText="Hủy"
        okText={isCreateNewItem ? 'Lưu' : 'Cập nhật'}
        title={isCreateNewItem ? 'Tạo mới' : 'Cập nhật'}
        onCancel={() => onCloseModal()}
        onOk={isCreateNewItem ? onCreateNewItem : onUpdateItem}
        width={'50vw'}
      >
        <div className="p-2">
          <Form form={form} wrapperCol={{ span: 18 }} labelCol={{ span: 6 }}>
            <Form.Item label="Hạng mục" name="name">
              <Input />
            </Form.Item>
            <Form.Item label="Mô tả" name="description">
              <Input />
            </Form.Item>
            <Form.Item label="Hệ số công" name="estimateCost">
              <InputNumber min={0} step={0.1} className="w-full" />
            </Form.Item>
            <Form.Item label="Đơn vị" name="unitNum">
              <Select options={workItemUnitOptions} />
            </Form.Item>
            <Form.Item label="Trạng thái" name="status">
              <Select
                options={[
                  {
                    label: <Tag color="green">Hoạt động</Tag>,
                    value: 1,
                  },
                  {
                    label: <Tag color="red">Không hoạt động</Tag>,
                    value: 0,
                  },
                ]}
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  );
}
